import { render, staticRenderFns } from "./TelegramButton.vue?vue&type=template&id=60db1dae&scoped=true&"
import script from "./TelegramButton.vue?vue&type=script&lang=js&"
export * from "./TelegramButton.vue?vue&type=script&lang=js&"
import style0 from "./TelegramButton.vue?vue&type=style&index=0&id=60db1dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db1dae",
  null
  
)

export default component.exports